/* necalli header/footer behaviour — loaded on every page */
(function () {
  'use strict';
  var design = !!(window.Shopify && window.Shopify.designMode);
  var nav = null, lastY = window.scrollY;
  function find() { nav = document.querySelector('[data-nc-nav]'); }
  function onScroll() {
    if (!nav || design) return;
    var y = window.scrollY, vh = window.innerHeight;
    if (y > lastY && y > vh * 0.6) nav.classList.add('is-hidden'); else nav.classList.remove('is-hidden');
    lastY = y;
  }
  function closeMenu() { document.documentElement.classList.remove('nc-menu-open'); document.querySelectorAll('[data-nc-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
  function bind(root) {
    root.querySelectorAll('[data-nc-menu-toggle]').forEach(function (btn) {
      if (btn.__nc) return; btn.__nc = true;
      btn.addEventListener('click', function () {
        var open = document.documentElement.classList.toggle('nc-menu-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    root.querySelectorAll('[data-nc-menu-close]').forEach(function (b) { if (b.__nc) return; b.__nc = true; b.addEventListener('click', closeMenu); });
  }
  function boot() { find(); bind(document); window.addEventListener('scroll', onScroll, { passive: true }); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  document.addEventListener('shopify:section:load', function (e) { find(); bind(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
